import(/* webpackMode: "eager" */ "/vercel/path0/src/app/products/mantra-3x3/page.tsx");
